var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"skip-to-main absolute overflow-hidden",attrs:{"href":_vm.href}},[_vm._v("Skip to main content")])}
var staticRenderFns = []

export { render, staticRenderFns }